import img16a from '../../../assets/gallery/16c/16c-01-HOME_Pasaje-3-2016-405x295mm-oleo-sobre-papel.jpg';
import img16b from '../../../assets/gallery/16c/16c-02_Pasaje-1-2016-405x295mm-oleo-sobre-papel.jpg';
import img16c from '../../../assets/gallery/16c/16c-03_Pasaje-2-2016-405x295mm-oleo-sobre-papel.jpg';
import img16d from '../../../assets/gallery/16c/16c-04_Pasaje-4-2016-405x295mm-oleo-sobre-papel.jpg';
import img16e from '../../../assets/gallery/16c/16c-05-ST-2016-405x295mm-oleo-sobre-papel.jpg';


export const dataImages = [
  {
    id: 1,
    title: "40,5 x 29,5 cm",
    dimensions: "",
    pictureSrc: img16a,
    description: "2016",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "40,5 x 29,5 cm",
    pictureSrc: img16b,
    description: "2016",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "40,5 x 29,5 cm",
    pictureSrc: img16c,
    description: "2016",
    orientation: "v"
  },
  {
    id: 4,
    title: "",
    dimensions: "40,5 x 29,5 cm",
    pictureSrc: img16d,
    description: "2016",
    orientation: "v"
  },
  {
    id: 5,
    title: "",
    dimensions: "40,5 x 29,5 cm",
    pictureSrc: img16e,
    description: "2016",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/16c/data16c.js